import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-contracts',
  templateUrl: './edit-contracts.component.html',
  styleUrls: ['./edit-contracts.component.scss']
})
export class EditContractsComponent implements OnInit {

    productId: string | null = null;


   product: any = {
    user_id: '',
    contract_type_id: '',
    duration_months: '',
    investment_amount: '',
    investment_rate: '',
    investment_rate_max:'',
    profit_amount: '',
    existing_pdf: null,
    pdf: null

  };

  pages: any[] = []; // For dropdown of contract types
  InvestorsId: any;



constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApisService,
    private toastr: ToastrService,
    public _translateService: TranslateService
  ) {}
    ngOnInit(): void {
    // get product id from route
    this.productId = this.route.snapshot.paramMap.get('id');

    if (this.productId) {
      this.loadProduct(this.productId);
    }

        this.getContractTypes();
        this.getInvestorsId();

  }


    // ✅ Fetch all contract types for dropdown
  getContractTypes(): void {
    this.apiService.contractsType().subscribe({
      next: (response: any) => {
        this.pages = response.data || [];
      },
      error: (error) => console.error('Failed to load contract types:', error),
    });
  }


  
  // ✅ Load contract data by ID
loadProduct(id: string): void {
  this.apiService.getContractsById(id).subscribe({
    next: (res: any) => {
      if (res?.data) {
        this.product = res.data;

        // store existing pdf separately
        this.product.existing_pdf = res.data.pdf;
      }

      console.log(this.product, 'this.data R');
    },
    error: (err) => {
      console.error('Failed to load product:', err);
    },
  });
}

    onFileSelected(event: any): void {
    if (event.target.files.length > 0) {
      this.product.image = event.target.files[0];
    }
  }
  // Update product
getInvestorsId(){ 
  this.apiService.investors().subscribe({
    next: (response: any) => {
      // The actual array is in response.data.data
      this.InvestorsId = response.data;  

     
      console.log("InvestorsId:", this.InvestorsId);
    },
    error: (error: any) => {
      console.log(error);
    }
  }
    
  )
 }
  
    // ✅ Update contract
updateProduct(): void {
  if (!this.productId) {
    this.toastr.error(this._translateService.instant('MENU.DASHBOARD.contract_id_missing'));
    return;
  }

  // Build FormData instead of plain JSON
  const formData = new FormData();
formData.append('_method', 'PUT'); 
  formData.append('user_id', this.product.user_id);
  formData.append('contract_type_id', this.product.contract_type_id);
  formData.append('duration_months', this.product.duration_months);
  formData.append('investment_amount', this.product.investment_amount);
  formData.append('investment_rate', this.product.investment_rate);
    formData.append('investment_rate_max', this.product.investment_rate_max);

if (this.product.pdf) {
  formData.append('pdf', this.product.pdf);
}
  this.apiService.editContracts(this.productId, formData).subscribe({
    next: () => {
      this.toastr.success(this._translateService.instant('MENU.DASHBOARD.contract_updated_successfully'));
      this.router.navigate(['/contracts']);
    },
    error: (err) => {
      console.error('Update failed:', err);
      if (err.error?.errors) {
        const errors = err.error.errors;
        Object.keys(errors).forEach(key => this.toastr.error(errors[key][0]));
      } else {
        this.toastr.error(this._translateService.instant('MENU.DASHBOARD.failed_to_update_contract'));
      }
    },
  });
}


onPdfSelected(event: any): void {
  if (event.target.files.length > 0) {
    this.product.pdf = event.target.files[0];
    console.log('Selected PDF:', this.product.pdf);
  }
}
  // updateProductt(): void {
  //   if (!this.productId) return;

  //   if (
  //     this.product.password &&
  //     this.product.password !== this.product.password_confirmation
  //   ) {
  //     this.toastr.error('Passwords do not match');
  //     return;
  //   }

  //   const form = new FormData();
  //   form.append('name', this.product.name);
  //   form.append('email', this.product.email);
  //   form.append('mobile', this.product.mobile);

  //   if (this.product.password) {
  //     form.append('password', this.product.password);
  //     form.append('password_confirmation', this.product.password_confirmation);
  //   }

  //   if (this.product.image) {
  //     form.append('image', this.product.image);
  //   }

  //   this.apiService.editreproductions(this.productId, form).subscribe({
  //     next: () => {
  //       this.toastr.success('User updated successfully');
  //       this.router.navigate(['/users']);
  //     },
  //     error: (err) => {
  //       console.error('Update failed:', err);
  //       this.toastr.error('Failed to update user');
  //     }
  //   });
  // }

}
